import styled from 'styled-components'

import { CampaignCardUnstyled } from 'Components/Campaigns/CampaignCard/unstyled'
import {
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
} from '../../../shared/constants'

const CampaignCard = styled(CampaignCardUnstyled)`
  position: relative;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.iron};
  background: ${props => props.theme.colors.white};
  padding: 18px;
  cursor: ${props => props.clickable && 'pointer'};

  .campaign-id{
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 12px;
    opacity: 0.5;
  }
  .actions {
    display: flex;
    flex-wrap: nowrap;
    a {
      margin: 8px 10px 0 0;
    }
  }
  .name {
    position: relative;
    padding: 0 0 0 55px;
    height: 44px;

    .campaign-status {
      position: absolute;
      width: 12px;
      height: 12px;
      background: ${({ status }) => {
        switch (status) {
          case STATUS_CAMPAIGN_ENUM_ACTIVE:
            return '#00F700'
          case STATUS_CAMPAIGN_ENUM_ARCHIVE:
            return '#424143'
          case STATUS_CAMPAIGN_ENUM_DRAFT:
            return '#FFDB00'
          case STATUS_CAMPAIGN_ENUM_COMPLETED:
            return '#004360'
        }
      }};
      border: 2px solid white;
      left: 0;
      top: 0;
      border-radius: 50%;
      z-index: 1;
    }

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }

    .campaign-name {
      color: ${props => props.theme.colors.oxfordBlue};
      font-size: ${props => props.theme.fontSizes.campaigns.card.campaignName};
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 50%;
      line-height: 22px;
    }

    .client-name {
      color: ${props => props.theme.colors.regentGray};
      font-size: ${props => props.theme.fontSizes.campaigns.card.clientName};
      text-transform: uppercase;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 50%;
      line-height: 22px;
    }
  }

  .duration-archived-company {
    color: ${props => props.theme.colors.regentGray};
    width: 100%;
    max-width: max-content;
    align-self: center;
    height: 20px;
    margin-top: 8px;
    font-size: ${props => props.theme.fontSizes.campaigns.card.bottom};
  }

  .MuiChip-root {
    position: absolute;
    top: -14px;
    right 14px;
  }

  .number-of-cities,
  .flyers {
    color: ${props => props.theme.colors.regentGray};
    font-size: ${props => props.theme.fontSizes.campaigns.card.bottom};
  }

  .number-of-cities {
    position: relative;
    margin: 8px 0 0 0;

    .number {
      position: absolute;
      right: 0;
      color: ${props => props.theme.colors.oxfordBlue};
    }
  }

  .campaign-progress-bar {
    margin: 20px 0 0 0;
    height: 4px;

    .main-bar {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 2px;
      background: ${props => props.theme.colors.mystic};

      .current-progress {
        position: absolute;
        width: ${props => props.progressBarValue || 0}%;
        height: 100%;
        border-radius: 2px;
        background: red;
        left: 0;
        top: 0;

        &.empty {
          background: ${props => props.theme.colors.regentGray};
        }

        &.start {
          background: ${props => props.theme.colors.curiousBlue};
        }

        &.end {
          background: ${props => props.theme.colors.forestGreen};
        }
      }
    }
  }

  .flyers {
    position: relative;
    margin: 12px 0 0 0;

    .numbers {
      position: absolute;
      right: 0;
      font-family: ${props => props.theme.fonts.robotoMedium};

      .current {
        &.empty {
          color: ${props => props.theme.colors.regentGray};
        }

        &.start {
          color: ${props => props.theme.colors.curiousBlue};
        }

        &.end {
          color: ${props => props.theme.colors.forestGreen};
        }
      }

      .target {
        color: ${props => props.theme.colors.oxfordBlue};
      }
    }
  }
`

export default CampaignCard
